import axios from "../config/axios-chatbot";

export const CampaignRepository = {
  getAll: (flow) => {
    return axios.get(`/api/campaign`, {params: {flow}});
  },
  get: (id) => {
    return axios.get(`/api/campaign/${id}`);
  },
  create: (data) => {
    return axios.post(`/api/campaign`, data);
  },
  update: (id, data) => {
    return axios.put(`/api/campaign/${id}`, data);
  },
  delete: (id) => {
    return axios.delete(`/api/campaign/${id}`);
  },

  // Phone numbers
  getPhoneNumbers: (id, {status, page = 0, size = 20} = {}) => {
    return axios.get(`/api/campaign/${id}/phone-numbers`, {params: {status: status || undefined, page, size}});
  },
  addPhoneNumbers: (id, phoneNumbers) => {
    return axios.post(`/api/campaign/${id}/phone-numbers`, {phoneNumbers});
  },
  deletePhoneNumber: (id, phoneNumberId) => {
    return axios.delete(`/api/campaign/${id}/phone-numbers/${phoneNumberId}`);
  },

  // Outbound calls
  callPhoneNumber: (id, phoneNumberId) => {
    return axios.post(`/api/campaign/${id}/phone-numbers/${phoneNumberId}/call`);
  },
  getAttempts: (id, phoneNumberId) => {
    return axios.get(`/api/campaign/${id}/phone-numbers/${phoneNumberId}/attempts`);
  },
}
